export { default as Dashboard } from './Dashboard';
export { default as DocumentationIndex } from './DocumentationIndex';
export { default as Login } from './Login';
export { default as PatientDetails } from './PatientDetails';
export { default as Settings } from './Settings';
export { default as Reports } from './Reports';
